















import {Vue, Component, Ref, Prop, Watch, Emit} from 'vue-property-decorator';
import {StoreModel} from "@/views/Objekti/StoreModel";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import {mixins} from "vue-class-component";
import {loadedGoogleMapsAPI} from "@/plugins/maps.plugin";

declare const google: any;

@Component({})
export default class ObjektiCard2Tab7Lokacija extends mixins(ComponentBaseMixin) {
  @Prop() store!: StoreModel;

  map: any = '';
  mapCenter = {lat: 45.262231, lng: 19.8518579};
  marker: any = '';

  latitudeFromDrag = '';
  longitudeFromDrag = '';

  async mounted() {
    loadedGoogleMapsAPI.then(() => {
      this.map = new google.maps.Map(document.getElementById('map'), {
        center: this.mapCenter,
        zoom: 8
      });
    });
  }

  @Watch('store', {deep: true}) onStoreValueChange(value) {
    if (this.map) {
      if (value.latitude && value.longitude) {
        if (this.marker) {
          this.marker.setPosition(new google.maps.LatLng(value.latitude, value.longitude));
        } else {
          this.addMarker(new google.maps.LatLng(value.latitude, value.longitude));
        }
        this.marker.setMap(this.map)
        this.map.setCenter(this.marker.getPosition());
      } else {
        if (this.marker) {
          this.map.setCenter(this.mapCenter);
          this.removeLocation();
        }
      }
    }
  }

  addMarker(LatLng) {
    if (this.marker) {
      this.marker.setMap(null);
      this.marker = null;
    }
    this.marker = new google.maps.Marker(
        {position: LatLng, draggable: true, animation: google.maps.Animation.DROP});
    this.updateStoreLatLng(LatLng.lat(), LatLng.lng());

    google.maps.event.addListener(this.marker, 'dragend', (evt) => {
      this.latitudeFromDrag = evt.latLng.lat();
      this.longitudeFromDrag = evt.latLng.lng();
    });
  }

  removeLocation() {
    if (this.marker) {
      this.marker.setMap(null);
      this.marker = null;
      this.removeLocationEmit();
    }
  }

  addLocation() {
    if (this.store.billingAddress && this.store.city) {
      if (!this.marker) {
        let geocoder = new google.maps.Geocoder();
        geocoder.geocode({
          address: `${this.store.billingAddress} ${this.store.city}`
        }, (results, status) => {
          if (google.maps.GeocoderStatus.OK === status) {
            let location = results[0].geometry.location;
            this.addMarker(location);
            this.map.setCenter(location);
            this.marker.setMap(this.map);
          } else {
            this.showError(`Geocode was not successful for the following reason: ${status}`);
          }
        });
      }
    }
  }

  @Emit() save() {
    if (this.latitudeFromDrag && this.longitudeFromDrag) {
      this.updateStoreLatLng(this.latitudeFromDrag, this.longitudeFromDrag);
    }
    this.latitudeFromDrag = null;
    this.longitudeFromDrag = null;
  }

  @Emit() removeLocationEmit() {
  }

  @Emit() updateStoreLatLng(Lat, Lng) {
  }

}
